module.exports = __webpack_public_path__ + "img/beetle.be5030ca.webp";